export default __webpack_public_path__ + "static/media/csv.ff92e2dd.PNG";